import { ViewingData } from '../../../types';
import Chart from '../../shared/Chart';

interface ResiViewingProps {
  data: ViewingData[];
}

const ResiViewing = ({ data }: ResiViewingProps) => {
  return (
    <Chart
      data={data}
      bars={[
        { dataKey: 'live', fill: '#8884d8', name: 'Live' },
        { dataKey: 'onDemand', fill: '#82ca9d', name: 'On Demand' },
      ]}
      height={250}
      ariaLabel="Resi viewing statistics comparing live and on-demand views over time"
    />
  );
};

export default ResiViewing;
